import { useTranslation } from 'react-i18next';
import { Category } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { WAGERING_SLIDER_PARAMS } from '@/helpers/games';
import { getSliderParams } from '@/helpers/getSliderParams';
import { useResponsive } from '@/modules/client';
import { useWageringGames } from '@/modules/games/hooks';
import LobbyGamesSlider from '../LobbyGamesSlider';

export const WageringGamesSlider = () => {
  const { t } = useTranslation('common');
  const { currentMediaType } = useResponsive();
  const { allGames } = getSliderParams(
    WAGERING_SLIDER_PARAMS,
    currentMediaType
  );

  const { games, totalCount } = useWageringGames({ pageSize: allGames });

  return (
    <LobbyGamesSlider
      categoryId={Category.WAGERING}
      gamesLength={totalCount}
      gamesList={games}
      sliderParams={WAGERING_SLIDER_PARAMS}
      title={t(`common:gameCategories.${Category.WAGERING}`)}
      titleIcon={
        <ImageComponent
          alt="icon"
          height={24}
          src="/wageringIcon.webp"
          width={24}
        />
      }
    />
  );
};
